import { registerSW } from 'virtual:pwa-register';

/**
 * Registro do service worker em modo 'prompt' (vite-plugin-pwa).
 * F0: nenhuma UI de atualização — só registra e expõe a função de aplicar quando houver
 * versão nova. A decisão de atualização com fila pendente é objeto do spike S8 e da F4/F9.
 */
export function registrarServiceWorker(): (recarregar?: boolean) => Promise<void> {
  const atualizar = registerSW({
    immediate: true,
    onNeedRefresh() {
      // F0: apenas registra no console; a UI de "atualizar agora / depois" vem em F9 (app_release).
      console.info('[pwa] nova versão disponível — aguardando decisão do usuário (modo prompt).');
    },
    onOfflineReady() {
      console.info('[pwa] pronto para uso offline.');
    },
    onRegisterError(erro: unknown) {
      console.warn('[pwa] falha ao registrar service worker', erro);
    },
  });
  return atualizar;
}
